module.exports = __webpack_public_path__ + "img/company13.c619493a.png";